import { type HelpArticleKind } from "./HelpArticle";

// Statystyki czytania centrum pomocy (TRE-2251). Źródłem jest zdarzenie
// `help_article_viewed` w PostHogu, a nie baza — materiał wiąże się z nim po
// parze (kind, slug), bo tak wysyła je client-web.

export const HELP_STATS_PERIODS = [7, 30, 90] as const;
export type HelpStatsPeriod = (typeof HELP_STATS_PERIODS)[number];

export interface HelpArticleStats {
  kind: HelpArticleKind;
  slug: string;
  /** Wszystkie otwarcia materiału w okresie. */
  views: number;
  /** Różne osoby (anonimowe przeglądarki liczone osobno). */
  visitors: number;
  /** Osoby, o których PostHog wie, kim są (zalogowane albo z linku z aplikacji). */
  knownVisitors: number;
  /** Otwarcia z aplikacji mobilnej (`source: "app"`). */
  appViews: number;
  lastViewedAt: string;
}

export interface HelpArticleReader {
  /** `person_id` z PostHoga — jedyne pole, które na pewno rozróżnia osoby. */
  id: string;
  name: string | null;
  email: string | null;
  views: number;
  appViews: number;
  lastViewedAt: string;
}
